import { DbMongoBaseInfos } from "./db-mongo-base-infos";
import { DeliveryMetadataExportOrigin } from "./delivery-metadata-export-origin";
import { DeliveryMetadataExportType } from "./delivery-metadata-export-type";

export class DbDeliveryMetadataExportInfos extends DbMongoBaseInfos {
  platformId: number | null = 0;
  origin: DeliveryMetadataExportOrigin | null = null;
  type: DeliveryMetadataExportType | null = null;
  name: string | null = null;
  tag: string | null = null;
  description: string | null = null;
  xslFilePath: string | null = null;
  template: string | null = null;
  liquidAssetExportFileType?: AssetLiquidExportFileType | null = null;
  liquidAssetExportChildMode?: AssetLiquidExportChilMode | null = null;

  constructor(init?: Partial<DbDeliveryMetadataExportInfos>) {
    super();
    Object.assign(this, init);
  }
}

export enum AssetLiquidExportFileType {
  Xml = "Xml",
  Csv = "Csv",
  Xls = "Xls",
  Xlsx = "Xlsx",
}

export enum AssetLiquidExportChilMode {
  None = "None",
  Recursively = "Recursively",
  GroupWithParent = "GroupWithParent",
}
